var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { staticClass: "p-0", attrs: { "data-cy": "buttons-group-container" } },
    [
      _c(
        "v-row",
        { attrs: { "no-gutters": "", "data-cy": "buttons-group-row" } },
        [
          _c(
            "v-col",
            { attrs: { "data-cy": "buttons-group-col" } },
            [
              _c(_vm.currentComponent, {
                tag: "component",
                attrs: {
                  "data-cy": "buttons-group-dynamic-component",
                  teamRequest: _vm.teamRequest,
                  refreshTeamRequest: _vm.refreshTeamRequest,
                  onSuccess: _vm.onSuccess,
                  onError: _vm.onError,
                  onOpenModal: _vm.openModal,
                  disabled: _vm.isDisabled,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("TRValidatedModal", {
        attrs: {
          "data-cy": "tr-validated-modal",
          isOpen: _vm.isTRValidatedModalOpen,
          onClose: _vm.closeModal,
          teamRequest: _vm.teamRequest,
          refreshTeamRequest: _vm.refreshTeamRequest,
          onSuccess: _vm.onSuccess,
        },
      }),
      _vm._v(" "),
      _c("TRCancelledModal", {
        attrs: {
          "data-cy": "tr-cancelled-modal",
          isOpen: _vm.isTRCancelledModalOpen,
          onClose: _vm.closeModal,
          teamRequest: _vm.teamRequest,
          refreshTeamRequest: _vm.refreshTeamRequest,
          onSuccess: _vm.onSuccess,
        },
      }),
      _vm._v(" "),
      _c("SendProposalModal", {
        attrs: {
          "data-cy": "send-proposal-modal",
          isOpen: _vm.isSendProposalModalOpen,
          onClose: _vm.closeModal,
          teamRequest: _vm.teamRequest,
          refreshTeamRequest: _vm.refreshTeamRequest,
          onSuccess: _vm.onSuccess,
        },
      }),
      _vm._v(" "),
      _c("NewProposalModal", {
        attrs: {
          "data-cy": "new-proposal-modal",
          isOpen: _vm.isNewProposalModalOpen,
          onClose: _vm.closeModal,
          teamRequest: _vm.teamRequest,
          refreshTeamRequest: _vm.refreshTeamRequest,
          onSuccess: _vm.onSuccess,
        },
      }),
      _vm._v(" "),
      _c("SavedToPendingTRModal", {
        attrs: {
          "data-cy": "saved-to-pending-tr-modal",
          isOpen: _vm.isSavedToPendingTRModalOpen,
          onClose: _vm.closeModal,
          teamRequest: _vm.teamRequest,
          refreshTeamRequest: _vm.refreshTeamRequest,
          onSuccess: _vm.onSuccess,
          onError: _vm.onError,
          disabled: _vm.isDisabled,
        },
      }),
      _vm._v(" "),
      _c("SavedTROnlyAvailableStemdoersModal", {
        attrs: {
          "data-cy": "saved-tr-only-available-stemdoers-modal",
          isOpen: _vm.isSavedToPendingTROnlyAvailablesModalOpen,
          onClose: _vm.closeModal,
          teamRequest: _vm.teamRequest,
          refreshTeamRequest: _vm.refreshTeamRequest,
          onSuccess: _vm.onSuccess,
          onError: _vm.onError,
        },
      }),
      _vm._v(" "),
      _c("AcceptTRModal", {
        attrs: {
          "data-cy": "accept-tr-modal",
          isOpen: _vm.isAcceptTRModalOpen,
          onClose: _vm.closeModal,
          teamRequest: _vm.teamRequest,
          refreshTeamRequest: _vm.refreshTeamRequest,
          onSuccess: _vm.onSuccess,
          onError: _vm.onError,
          disabled: _vm.isDisabled,
        },
      }),
      _vm._v(" "),
      _c("CheckCartSaveTrModal", {
        attrs: {
          "data-cy": "check-cart-save-tr-modal",
          title: _vm.$t(
            "teamRequestDetail.modal.client.acceptTeamRequest.title"
          ),
          isOpen: _vm.isCheckCartSaveTrModalOpen,
          onClose: _vm.closeModal,
          teamRequestId: _vm.teamRequest.id,
        },
      }),
      _vm._v(" "),
      _c("AcceptTROnlyAvailableStemdoersModal", {
        attrs: {
          "data-cy": "accept-tr-only-available-stemdoers-modal",
          isOpen: _vm.isAcceptTeamRequestOnlyAvailableModalOpen,
          onClose: _vm.closeModal,
          teamRequest: _vm.teamRequest,
          refreshTeamRequest: _vm.refreshTeamRequest,
          onSuccess: _vm.onSuccess,
          onError: _vm.onError,
        },
      }),
      _vm._v(" "),
      _c("TrApprovedModal", {
        attrs: {
          "data-cy": "approved-by-manager-modal",
          isOpen: _vm.isApprovedByManagerModalOpen,
          onClose: _vm.closeModal,
          teamRequest: _vm.teamRequest,
          refreshTeamRequest: _vm.refreshTeamRequest,
          onSuccess: _vm.onSuccess,
          onError: _vm.onError,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }